import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import MobileAppBadges from '../../../shared/MobileAppBadges';
import ProgressBars from '../../../shared/ProgressBars';
import Support from '../../../shared/Support';
import Tooltip from '../../../shared/Tooltip';

export default function NextSteps({ company }) {
  const minRate = company?.min_rate || 'N/A';
  const maxRate = company?.max_rate || 'N/A';

  return (
    <div>
      <ProgressBars />
      <div className="my-4 flex items-center">
        <span className="fa-layers fa-fw text-5xl">
          <FontAwesomeIcon
            icon="square"
            className="text-background-success !mx-0"
          />
          <FontAwesomeIcon
            icon={['far', 'circle-check']}
            className="text-success text-3xl !mx-1.5"
          />
        </span>
        <div className="text-2xl sm:text-4xl font-extrabold">Approved</div>
      </div>
      <div className="font-light sm:text-lg tracking-wide mb-4 flex flex-col gap-4">
        <div>You're good to go! We told you it would be easy.</div>
      </div>
      <div className="p-3 px-4 sm:p-6 border border-primary-border-gray rounded-lg">
        <div className="flex items-center justify-center">
          <p className="text-xl">
            Your base rate: <span className="font-bold">{`${minRate}%`}</span>
          </p>
          <Tooltip
            tooltipText={`Your rate may range from ${minRate}-${maxRate}% depending on term selection`}
            containerClass="rounded-lg w-72 p-3 bg-border-gray text-xs"
            placement="top"
          >
            <FontAwesomeIcon
              icon={['fal', 'info-circle']}
              className="text-secondary-gray ml-2 text-sm cursor-help"
            />
          </Tooltip>
        </div>
      </div>
      <div className="p-3 px-4 sm:p-6 border border-primary-border-gray rounded-lg my-4">
        <h3 className="text-xl font-bold mb-4">
          Next steps to activate your virtual card
        </h3>
        <div className="flex flex-col gap-6">
          <div>
            <div className="text-base font-bold mb-3">
              1. Download the Credit Key iOS or Android App
            </div>
            <MobileAppBadges />
          </div>
          <div>
            <div className="text-base font-bold mb-2">
              2. Activate your Credit Key Card
            </div>
            <div className="text-sm text-secondary-gray">
              In the Credit Key iOS or Android mobile app, activate your Credit
              Key Card from the app's Home or Wallet screen.
            </div>
          </div>
          <div>
            <div className="text-base font-bold mb-2">
              3. Add Card to your phone's digital wallet
            </div>
            <div className="text-sm text-secondary-gray">
              View your Credit Key Card in the mobile app and tap Add to Wallet.
            </div>
          </div>
        </div>
      </div>
      <Support />
    </div>
  );
}
